__turbopack_context__.v({
  "buttonLabel": "BuIsVq_buttonLabel",
  "dateLabel": "BuIsVq_dateLabel",
  "drawerContent": "BuIsVq_drawerContent",
  "iconWrapper": "BuIsVq_iconWrapper",
  "iconWrapperOpen": "BuIsVq_iconWrapperOpen",
  "styledDrawer": "BuIsVq_styledDrawer",
  "styledDrawerWithRibbon": "BuIsVq_styledDrawerWithRibbon",
  "timerLabel": "BuIsVq_timerLabel",
  "timerWrapper": "BuIsVq_timerWrapper",
});
